import { useQuery } from 'react-query';
import GroupConfigurationAPI from 'services/API/GroupConfigurationAPI';
import { Region } from 'utils/constants/location';

export const usePresetFilters = ({
  presetFilterName,
  region,
}: {
  presetFilterName?: string;
  region: Region | null;
}) => {
  return useQuery({
    queryKey: ['presetFilters', presetFilterName, region],
    queryFn: async () => {
      if (!presetFilterName) {
        return null;
      }

      const response = await GroupConfigurationAPI.getPresetFilters({
        presetFilterName,
        mercatorMetropolitanCode: region!,
      });

      return response?.data;
    },
    enabled: !!presetFilterName || !!region,
    refetchOnWindowFocus: false,
  });
};
